import React from 'react';
import { Divider as AntDivider } from 'antd';

const Divider = ({ color }) => {
    return (
        <AntDivider
            style={{
                color: color,
                backgroundColor: color,
                height: 5
            }}
        />
    )
}

export default Divider